export const FEEDBACK_REQUEST_MESSAGE_TYPES = {
  AUTOREPLY: 'auto_reply_feedback_request_message',
  CHATBOT: 'chatbot_feedback_request_message',
  CONVERSATIONAL_CHATBOT: 'conversational_chatbot_feedback_request_message',
}
export const getKeyPrefix = (messageType: string): string => {
  switch (messageType) {
    case FEEDBACK_REQUEST_MESSAGE_TYPES.AUTOREPLY:
      return 'auto_reply_rating_form'
    case FEEDBACK_REQUEST_MESSAGE_TYPES.CHATBOT:
      return 'virtual_assistant_rating_form'
    case FEEDBACK_REQUEST_MESSAGE_TYPES.CONVERSATIONAL_CHATBOT:
      return 'conversational_chatbot_rating_form'
    default:
      return ''
  }
}
